$('.generate-table-of-contents').each(function() {
    let $list = $(this),
        $content = $('#'+ $(this).data('target-content'));

    if ($content.length > 0) {
        // scan for heading tags
        let $headings = $content.find('h1, h2, h3, h4, h5, h6');

        if ($headings.length > 0) {
            $headings.each(function () {
                let value = $(this).text().trim(),
                    headingID = value.trim().replace(/[\W_]/g, '-').toLowerCase(); // all special characters are converted to a dash

                if ('' === value) return;

                if ('-' === headingID[headingID.length -1]) { // if last character in string is dash, trim it off
                    headingID = headingID.slice(0, -1);
                }

                if (headingID.indexOf('--') >= 0) { // check for double dashes (rare)
                    headingID = headingID.replace('--', '-');
                }

                $(this).attr('id', headingID);

                $list.append('<li><i class="far fa-angle-right"></i><a href="#'+ headingID +'" title="'+ value +'">'+ value +'</a></li>');
            });
        } else {
            $list.closest('.widget').remove();
        }
    } else {
        $list.closest('.widget').remove();
    }
});
